import React, { useState, useEffect, useCallback } from "react";
import { useParams } from 'react-router-dom';

// Component Imports
import Preloader from '../../components/Preloader';
import Banner from '../../components/Banner';
import SingleBlog from "../../components/SingleBlog";

// Utility Imports
import { capitalizeWords } from '../../utils/Helper'

/**
 * BlogDetailsPage - Displays the blog details page based on URL slug.
 *
 * Applies page-specific classes on mount and cleans up on unmount.
 */
const BlogDetails = () => {
    const { slug } = useParams();
    const [attributes, setAttributes] = useState([]);
    
    const pageTitle = slug 
        ? capitalizeWords(slug.replace(/-/g, ' '))
        : 'Blog Details';
    
    useEffect(() => {
        document.body.classList.add( 'inner-page', 'blog', 'blog-details' );

        return () => {
            document.body.classList.remove( 'inner-page', 'blog', 'blog-details' );
        }
    }, [] );

    const handleLoadAttributes = useCallback((list) => {
        setAttributes(prev => {
            return JSON.stringify(prev) !== JSON.stringify(list) ? list : prev;
        });
    }, []);
    
    return (
        <>
			<Preloader />
			<Banner page={{ title: pageTitle, type: 'blog', attributes }} />
            <SingleBlog onLoadAttributes={ handleLoadAttributes } />
		</>
    );
}

export default BlogDetails;